import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { getStrDate } from "../../../../global/utils/diasData";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { wsPostTurnosKinesioQr } from "../../../context/Actions/turnos/estudioTurnos";
import IconBlack from "../../../assets/images/generico/IconBack";
import HeaderTimer from "../../Genericos/HeaderTimer/HeaderTimer";
import ConsultaIcon from "../../../assets/images/generico/ConsultaIcon";
import ViewIcon from "../../../assets/images/generico/ViewIcon";
import EtiquetaGrupoModal from "../EtiquetaGrupoModal/EtiquetaGrupoModal";
import "./HeaderBarKin.css";
import fechaTurnoFormat from "../../../../global/utils/fechaTurnoFormat";
import { GlobalContext } from "../../../../global/context/Provider";
import isIosNative from "global/utils/isIosNative";
import { HeaderBarFiltrosKinContainer } from "./localStyle";

const HeaderBarKin = ({ handleClickVolver, handleActualizaTurnos }) => {
  const { modalDispatch, turnosDisponiblesState, estudioTurnosDispatch } =
    useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch } = useContext(GlobalContext);

  const [descEspecialidad, setDescEspecialidad] = useState(false);
  const [grupoMedicoOk, setGrupoMedicoOk] = useState(false);
  const [agrupaEtiqueta, setAgrupaEtiqueta] = useState(false);
  const [onChangeDate, setOnChangeDate] = useState(null);
  const [flgTurnosKin, setFlgTurnosKin] = useState(false);
  const [iosInfo, setIosInfo] = useState(false);
  async function infoIos() {
    const isIosNativeMobile = await isIosNative.logDeviceInfo();
    setIosInfo(isIosNativeMobile);
    return isIosNativeMobile;
  }
  infoIos();
  const fecha = new Date();

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const onChangeDatePicker = (e) => {
    if (e !== null) {
      setOnChangeDate(e);
    }
  };

  const showModalKinesio = () => {
    //saco el domingo ya que no entra dentro de los dias.
    showModal(
      "Turnos/FiltrosKinesio/FiltrosKinesio",
      {
        titulo: "Filtrar por dia y hora",
        dissmiss: dissmiss,
        onChangeDatePicker: onChangeDatePicker,
        onHandleBuscarTurnosKin: onHandleBuscarTurnosKin,
        fecha: fecha,
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  const onHandleBuscarTurnosKin = () => {
    setFlgTurnosKin(true);
  };

  useEffect(() => {
    if (flgTurnosKin) {
      let auxDias =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.diasKin.filter(
          (item) => item.checked !== false && item.id !== 0
        );
      let auxKin =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.rangoKinesio.filter(
          (item) => item.checked !== false && item.id !== 0
        );

      // // Filtrado provisorio de días
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .diasKin[0]?.checked
      ) {
        auxDias =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.diasKin.filter(
            (item) => item.id !== 0
          );
      }

      // // Filtrado provisorio de rangoKinesio
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .rangoKinesio[0]?.checked
      ) {
        auxKin =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.rangoKinesio.filter(
            (item) => item.id !== 0
          );
      }

      if (auxDias.length >= 3 && auxKin.length > 0) {
        auxDias = auxDias.map((array) => array.id);
        auxKin = auxKin.map((array) => array.rango);
        let dtoKin = {
          cantidad: 10,
          fechaDesde: onChangeDate !== null ? onChangeDate : fechaTurnoFormat(),
          idGrupoMedico:
            turnosDisponiblesState.turnosDisponibles.turnosData.idEstudio,
          listDias: auxDias,
          listHorario: auxKin,
          particular:
            turnosDisponiblesState.turnosDisponibles.turnosData.particular,
        };
        setFlgTurnosKin(false);
        hideModal()(modalDispatch);
        handleActualizaTurnos();
        wsPostTurnosKinesioQr(dtoKin)(estudioTurnosDispatch);
      } else {
        setFlgTurnosKin(false);
        showToaster(
          {
            texto: "Seleccione al menos 1 rango horario y 3 dias de la lista",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    }
  }, [flgTurnosKin]);

  const onClickShowDeterminaciones = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "Tus turnos agregados",
        texto: <EtiquetaGrupoModal />,
        dissmiss: dissmiss,
      },
      [
        {
          text: "Continuar",
          clase: "btn-Mensaje-1 bgc-black10 cursor:pointer rb18m c-white",
          accion: dissmiss,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  useEffect(() => {
    if (
      turnosDisponiblesState.turnosDisponibles.turnosData.descEspecialidad !==
        "" &&
      turnosDisponiblesState.turnosDisponibles.turnosData.descEspecialidad !==
        null
    ) {
      setDescEspecialidad(true);
    }
    if (
      turnosDisponiblesState.turnosDisponibles.turnosData.grupoMedico !== null
    ) {
      setGrupoMedicoOk(true);
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.grupoMedico.length >
        1
      ) {
        setAgrupaEtiqueta(true);
      }
    }
  }, []);

  return (
    <React.Fragment>
      <HeaderBarFiltrosKinContainer className="c-white" isIos={iosInfo}>
        <div className="ptur-headerbarFiltros-volverBox">
          <button
            className="ptur-headerbarFiltros-volverBtn"
            onClick={handleClickVolver}
          >
            <IconBlack />
            <span className="ptur-headerbarFiltros-volverTxt rb18m">
              VOLVER
            </span>
          </button>
        </div>
        <div className="ptur-headerBarFiltros-filtros c-white">
          <button
            onClick={showModalKinesio}
            className="ptur-turnosDisponiblesKin-filtrosMobile-btn c-latex30 rb18mh"
          >
            Filtros
          </button>
        </div>
        <div className="ptur-headerBarFiltros-etiquetaTurno">
          <ConsultaIcon color={"var(--color-white)"} />
          {turnosDisponiblesState.turnosDisponibles.particular ? (
            <span className="ptur-headerBarFiltros-descParticular c-white rb14b">
              PARTICULAR:
            </span>
          ) : (
            ""
          )}
          <span className="ptur-headerBarFiltros-etiquetaTurnoDesc c-white rb14l">
            {grupoMedicoOk ? (
              agrupaEtiqueta ? (
                <button
                  onClick={() => onClickShowDeterminaciones()}
                  className="ptur-headerBarFiltros-btnTurno c-white"
                >
                  VER ESTUDIOS AGREGADOS
                  <span className="ptur-headerBarFiltros-viewIcon">
                    <ViewIcon />
                  </span>
                </button>
              ) : descEspecialidad ? (
                turnosDisponiblesState.turnosDisponibles.turnosData
                  .descEspecialidad
              ) : (
                turnosDisponiblesState.turnosDisponibles.turnosData.descEstudio
              )
            ) : descEspecialidad ? (
              turnosDisponiblesState.turnosDisponibles.turnosData
                .descEspecialidad
            ) : (
              turnosDisponiblesState.turnosDisponibles.turnosData.descEstudio
            )}
          </span>
        </div>
        <div className="ptur-headerBarFiltros-txtDiaHora">
          <p id="ptur-DiaResponsive" className="rb18m">
            {getStrDate(new Date())}
            <span className="ptur-timer">
              <HeaderTimer />
            </span>
          </p>
        </div>
      </HeaderBarFiltrosKinContainer>
      {/* <div
        className={
          iosInfo
            ? "ptur-headerbarFiltros-container c-white iosMobileStatusBarFix"
            : "ptur-headerbarFiltros-container c-white"
        }
      >

      </div> */}
    </React.Fragment>
  );
};

export default HeaderBarKin;
